import { render } from "./CommonContainer.vue?vue&type=template&id=2b0415c9"
import script from "./CommonContainer.vue?vue&type=script&lang=js"
export * from "./CommonContainer.vue?vue&type=script&lang=js"

import "./CommonContainer.vue?vue&type=style&index=0&id=2b0415c9&lang=css"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__